import React from "react";

interface Props {
  color: "red" | "green";
}

export default function (props: Props) {
  return (
    <div
      style={{
        height: 12,
        width: 12,
        background: props.color == "red" ? "#de1313" : "#4ffbb1",
        borderRadius: "50%"
      }}
    ></div>
  );
}
